<mat-card style="min-height: 500px">
    <mat-card-content>
        <div class="fw-bold fs-5 mb-1">
            Rules
        </div>
        <div class="small-text mb-3">
            {{ 'RULES_DESC_01' | translate }}
        </div>
        <div class="max-width">
            <div class="row mt-2">
                <ng-container>
                    <div class="col-md-12 d-flex mb-2">
                        <button
                            class="action-btn action-btn-create"
                            role="button"
                            (click)="onOpenModelAddRule()">
                            <i-feather name="plus" class="feather-base"></i-feather>
                            {{ 'Add Rules' | translate }}
                        </button>
                    </div>
                </ng-container>
            </div>
                <div class="form-group row mb-3">
                    <div class="col-md-3">
                        <app-select-school-level-relation-v2
                                [academic_year]="currentAcademic?.academic_year"
                                (schoolLevelRelationChanged)="onChangeSchoolLevel($event)" [isDisabled]="!currentAcademic">
                        </app-select-school-level-relation-v2>
                    </div>
                    <div  class="col-md-3">
                        <app-select-school-program
                                [academic_year]="paramForm.get('academic_year')?.value"
                                [school_location_id]="paramForm.get('school_location_id')?.value"
                                [isDisabled]="!paramForm.get('school_location_id')?.value"
                                (schoolProgramChanged)="onChangeSchoolProgram($event)">
                        </app-select-school-program>
                    </div>
                </div>
            <div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="margin-top:70px">
                <mat-spinner></mat-spinner>
            </div>
            <div>
                <app-status-no-data [show]="total === 0 && !loading"></app-status-no-data>
            </div>
                <div class="table-responsive">
                    <table mat-table *ngIf="total > 0 && !loading"
                           [dataSource]="dataRules" multiTemplateDataRows
                           >

                        <ng-container matColumnDef="school_program_name" class="align-items-center">
                            <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'School Program Name' | translate }}</th>
                            <td mat-cell *matCellDef="let element" class="example-element-name" style="text-align: center">
                                {{element.school_program_name}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="year_level">
                            <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'Year Level' | translate }}</th>
                            <td mat-cell *matCellDef="let element" class="example-element-symbol" style="text-align: center">
                               <span *ngFor="let data of element.yearLevels">
                                    {{data.description}}
                                   <br>
                                </span>

                            </td>
                        </ng-container>

                        <ng-container matColumnDef="valid_from" class="align-items-center">
                            <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'Valid From' | translate }}</th>
                            <td mat-cell *matCellDef="let element" class="example-element-name" style="text-align: center">
                                {{element.valid_from}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="selection" class="align-items-center">
                            <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'Selection' | translate }}</th>
                            <td mat-cell *matCellDef="let element" class="example-element-name" style="text-align: center">
                                {{element.minimum_selection}} - {{element.maximum_selection}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="action" *ngIf="auth.permissions['SCHOOL_PROGRAM_RULE_DELETE'] || auth.permissions['SCHOOL_PROGRAM_RULE_EDIT']">
                            <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'Actions' | translate }}</th>
                            <td mat-cell *matCellDef="let element" class="example-element-weight">
                            <div class="d-flex justify-content-center gap-1">
                                <button
                                    class="action-icon-btn action-icon-view"
                                    (click)="onOpenModelEditRule(element)"
                                    *ngIf="auth.permissions['SCHOOL_PROGRAM_RULE_EDIT']"
                                    [title]="'VIEW' | translate">
                                    <div>
                                        <i-feather name="eye" class="feather-base"></i-feather>
                                    </div>
                                </button>
                                <button
                                    class="action-icon-btn action-icon-delete"
                                    (click)="onDelete(element)"
                                    *ngIf="auth.permissions['SCHOOL_PROGRAM_RULE_DELETE']"
                                    [title]="'DELETE' | translate">
                                    <div>
                                        <i-feather name="trash-2" class="feather-base"></i-feather>
                                    </div>
                                </button>
                            </div>

                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>&ndash;&gt;-->
                        <tr mat-row *matRowDef="let element; let i = index; columns: columnsToDisplay;" class="example-element-row">
                        </tr>

                    </table>
                    <mat-paginator  *ngIf="total > 0 && !loading"
                            [pageSize]="15"
                                   (page)="onChangePage($event)"
                                   [length]="total"
                                   showFirstLastButtons></mat-paginator>
                </div>
        </div>
    </mat-card-content>
</mat-card>

<ng-template #addRule let-modal let-close="close">
        <form #programForm (ngSubmit)="onAddRule()" [formGroup]="newRuleForm">
            <div class="modal-header">
                <div class="row">
                    <div class="col-md-12">
                        <h5 class="modal-title">{{ 'Add Rule' | translate }}</h5>
                    </div>
                </div>
            </div>
            <ng-container>
                <div class="modal-body">
                    <div class="row float-start mb-5 d-grid col-md-12">
                        <div class="d-grid col-md-5 mb-2">
                                <app-select-school-level-relation-v2
                                (schoolLevelRelationChanged)="onChangeSchoolLevel($event, 'add')"
                                [academic_year]="currentAcademic?.academic_year"
                                [isDisabled]="!currentAcademic">
                                </app-select-school-level-relation-v2>
                        </div>
                        <div class="d-grid col-md-5 mb-2">
                            <app-select-school-program
                                    [academic_year]="newRuleForm.get('academic_year')?.value"
                                    [school_location_id]="newRuleForm.get('school_location_id')?.value"
                                    [isDisabled]="!newRuleForm.get('school_location_id')?.value"
                                    (schoolProgramChanged)="onChangeSchoolProgram($event, 'add')">
                            </app-select-school-program>
                        </div>
                        <div class="d-grid mb-2 col-md-12">
                            <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Valid From' | translate }}<span style="font-size: 16px; color: rgb(190, 0, 0);">*</span></span>
                            <input type="date" class="form-control col-md-4" placeholder="{{ 'Valid From' | translate }}" formControlName="valid_from">
                        </div>
                        <div class="d-grid table-container table-responsive" *ngIf="newRuleForm.get('school_program_id')?.value && yearLevelDataList.length > 0">
                                <table class="custom-table">
                                    <tr>
                                        <th>{{ 'Year Level' | translate }}</th>
                                        <th>{{ 'Min Selection' | translate }}</th>
                                        <th>{{ 'Max Selection' | translate }}</th>
                                    </tr>

                                    <tbody>
                                    <tr *ngFor="let year of yearLevelDataList; let i = index">
                                        <td>{{ year.year_level_name }}</td>
                                        <td>
                                            <input type="number" [(ngModel)]="year.minimum_selection" [ngModelOptions]="{standalone: true}"
                                                   class="custom-input" min="0" (input)="validateSelection(year, 'min', $event)" />
                                        </td>
                                        <td>
                                            <input type="number" [(ngModel)]="year.maximum_selection" [ngModelOptions]="{standalone: true}"
                                                   class="custom-input" min="0" (input)="validateSelection(year, 'max', $event)" />
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                        </div>
                        <div class="d-flex justify-content-end align-items-end">
                            <button type="submit" class="gradient-button col-md-2 mt-3" [disabled]="disableButtonAdd">{{ 'Save' | translate }}</button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </form>
</ng-template>

<ng-template #editRule let-modal let-close="close">
    <form (ngSubmit)="onEditRule()" [formGroup]="editRuleForm">
        <div class="modal-header">
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">{{ 'Edit Rule' | translate }}</h5>
                </div>
            </div>
        </div>
        <ng-container>
            <div class="modal-body">
                <app-status-loading [show]="!detailData"></app-status-loading>
                <div class="row float-start mb-5 d-grid col-md-12" *ngIf="detailData">
                    <div class="d-grid mb-2 col-md-12">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Valid From' | translate }}</span>
                        <input type="date" class="form-control col-md-3" placeholder="{{ 'Valid From' | translate }}" formControlName="valid_from">
                    </div>
                    <div class="d-grid table-container table-responsive">
                        <table class="custom-table">
                            <tr>
                                <th></th>
                                <th>{{ 'Year Level' | translate }}</th>
                                <th>{{ 'Min Selection' | translate }}</th>
                                <th>{{ 'Max Selection' | translate }}</th>
                            </tr>

                            <tbody>
                            <tr *ngFor="let year of editRuleForm.get('year_level')?.value; let i = index">
                                <td class="col-md-1"> <app-input-checkbox
                                        [name]="'is_block-' + i"
                                        [isChecked]="isChecked(year.year_level_id)"
                                        (onChecked)="onChecked(year.year_level_id)">
                                </app-input-checkbox>
                                </td>
                                <td>{{ year.description }}</td>
                                <td>
                                    <input type="number" [(ngModel)]="year.minimum_selection" [ngModelOptions]="{standalone: true}"
                                           class="custom-input" min="0" (input)="validateSelection(year, 'min', $event)" />
                                </td>
                                <td>
                                    <input type="number" [(ngModel)]="year.maximum_selection" [ngModelOptions]="{standalone: true}"
                                           class="custom-input" min="0" (input)="validateSelection(year, 'max', $event)" />
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <button type="submit" class="gradient-button col-md-2 mt-3 me-1">{{ 'Save' | translate }}</button>
                    </div>
                </div>
            </div>
        </ng-container>
    </form>
</ng-template>
